import { Component, OnInit, OnDestroy, ElementRef } from '@angular/core';
import videojs from 'video.js';
import * as adapter from 'webrtc-adapter/out/adapter_no_global.js';
import * as RecordRTC from 'recordrtc';

/*
// Required imports when recording audio-only using the videojs-wavesurfer plugin
import * as WaveSurfer from 'wavesurfer.js';
import * as MicrophonePlugin from 'wavesurfer.js/dist/plugin/wavesurfer.microphone.js';
WaveSurfer.microphone = MicrophonePlugin;

// Register videojs-wavesurfer plugin
import * as Wavesurfer from 'videojs-wavesurfer/dist/videojs.wavesurfer.js';
*/

// register videojs-record plugin with this import
import * as Record from 'videojs-record/dist/videojs.record.js';
import { ActivatedRoute, Router } from '@angular/router';
import { ModulemanagementService } from 'src/app/services/modules/modulemanagement.service';
import { ComponentheaderService } from 'src/app/services/componentheader.service';
import { ToastrService } from 'ngx-toastr';
import { UtilService } from 'src/app/services/util.service';
declare var $: any;

@Component({
  selector: 'app-recordvideo',
  templateUrl: './recordvideo.component.html',
  styleUrls: ['./recordvideo.component.css']
})
export class RecordvideoComponent implements OnInit, OnDestroy {
  private _elementRef: ElementRef

  // index to create unique ID for component
  idx = 'clip1';

  private config: any;
  private player: any;
  private plugin: any;
  moduleid: number = 0;
  moduleInfo: any = {};
  currentUserIsAdmin: any = false;
  file: File;
  uploading: boolean = false;
  uploadpercentage: number = 0;
  mediatitle: string = '';// `Upload ${new Date().toLocaleString()}`;
  stop = false;
  submitted: boolean = false;
  // constructor initializes our declared vars
  constructor(elementRef: ElementRef, private activatedroute: ActivatedRoute, public modulemanager: ModulemanagementService, private headerinfo: ComponentheaderService, private router: Router, private toastr: ToastrService, private util: UtilService) {
    this.player = false;

    // save reference to plugin (so it initializes)
    this.plugin = Record;

    // video.js configuration
    this.config = {
      controls: true,
      autoplay: true,
      fluid: false,
      loop: false,
      // width: 700,
      // height: 500,
      // aspectRatio: "1:1",
      // liveui: true,
      // children: {
      // bigPlayButton: true,
      controlBar: {
        volumePanel: {
          inline: false
        },
        ProgressControl: {
          // SeekBar: {
          //   PlayProgressBar: true
          // }
        }
        // }
      },
      playbackRates: [0.5, 1, 1.5, 2],

      plugins: {
        /*
        // wavesurfer section is only needed when recording audio-only
        wavesurfer: {
            backend: 'WebAudio',
            waveColor: '#36393b',
            progressColor: 'black',
            debug: true,
            cursorWidth: 1,
            displayMilliseconds: true,
            hideScrollbar: true,
            plugins: [
                // enable microphone plugin
                WaveSurfer.microphone.create({
                    bufferSize: 4096,
                    numberOfInputChannels: 1,
                    numberOfOutputChannels: 1,
                    constraints: {
                        video: false,
                        audio: true
                    }
                })
            ]
        },
        */
        // configure videojs-record plugin
        record: {
          pip: true,
          audio: true,
          video: true,
          debug: true,
          maxLength: 3600
        }
      }
    };
    // this.headerinfo.setHeaderDisplay('Loading...', [], []);
    this.mediatitle = '';
  }

  async ngOnInit() {
    this.headerinfo.pageLoadingStarted(this);
    this.moduleid = parseInt(this.activatedroute.snapshot.queryParams.moduleid);
    const data: any = await this.modulemanager.getModuleDetails(this.moduleid).toPromise();
    this.moduleInfo = data.moduleinfo;
    this.currentUserIsAdmin = data.isViewerAdmin;
    const schoolName: string = data.schoolName;
    const schoolid: number = data.schoolID;
    let moduleDisplayName = this.moduleInfo.name;
    if (this.moduleInfo.courseCode) {
      moduleDisplayName += ` (${this.moduleInfo.courseCode})`;
    }
    // $(".modal").on("click", function () {
    //   $('#entertitle').modal('hide');
    // });
    // this.headerinfo..setHeaderDisplay(null,null,
    //   // 'Upload Media',
    //   // [

    //   //   // {displaytext: schoolName, route: `/user/schoolhome`, params: {schoolID: schoolid}}, 
    //   //   { displaytext: "Course", route: `/user/moduledetails`, params: { moduleID: this.moduleid } },
    //   //   { displaytext: 'Media Library', route: '/user/modulemedialibrary', params: { moduleid: this.moduleid } },
    //   //   { displaytext: 'Upload Media', route: this.activatedroute.snapshot.url.join('/'), params: this.activatedroute.snapshot.queryParams }
    //   // ],
    //   []
    //   );

    this.headerinfo.pageLoadingDone(this);
  }

  // use ngAfterViewInit to make sure we initialize the videojs element
  // after the component template itself has been rendered
  ngAfterViewInit() {
    // ID with which to access the template's video element
    let el = 'video_' + this.idx;

    // setup the player via the unique element ID
    this.player = videojs(document.getElementById(el), this.config, () => {
      console.log('player ready! id:', el);

      // print version information at startup
      // var msg = 'Using video.js ' + videojs.VERSION +
      //   ' with videojs-record ' + videojs.getPluginVersion('record') +
      //   ' and recordrtc ' + RecordRTC.version;
      //videojs.log(msg);

      this.player.record().getDevice();
    });

    // device is ready
    this.player.on('deviceReady', () => {
      console.log('device is ready!');
      //this.player.record().start();
    });

    // user clicked the record button and started recording
    this.player.on('startRecord', () => {
      console.log('started recording!');
      var pauserecordbtn = this.player.controlBar.addChild("button");
      console.log(this.player.controlBar);
      var pauserecordbtnDom = pauserecordbtn.el();
     
      pauserecordbtnDom.className += ' fa fa-pause-circle';
      // pauserecordbtnDom.innerHTML = "&#xf28c;";
      pauserecordbtnDom.title = "Pause Recorder";
      pauserecordbtnDom.name = "pause-recorder";
      pauserecordbtnDom.id = "pause-recorder";
      pauserecordbtnDom.onclick = async () => {
        this.player.record().pause();
        console.log("recording paused");
        //var resumerecordbtn = this.player.controlBar.addChild("button");
        //console.log(this.player.controlBar);
        //var resumerecordbtnDom = resumerecordbtn.el();
       
        //resumerecordbtnDom.className += ' fa fa-play-circle';
        //// resumerecordbtnDom.innerHTML = "&#xf28c;";
        //resumerecordbtnDom.title = "Resume Recorder";
        //resumerecordbtnDom.id = "resume-recorder";
        //resumerecordbtnDom.name = "resume-recorder";
        //resumerecordbtnDom.onclick = async () => {
        //  this.player.record().resume();

        //}
      }
    });

    //this.player.on('pauseRecord', () => {
    //  console.log("recording paused");
    //  var resumerecordbtn = this.player.controlBar.addChild("button");
    //  console.log(this.player.controlBar);
    //  var resumerecordbtnDom = resumerecordbtn.el();
     
    //  resumerecordbtnDom.className += ' fa fa-play-circle';
    //  // resumerecordbtnDom.innerHTML = "&#xf28c;";
    //  resumerecordbtnDom.title = "Resume Recorder";
    //  resumerecordbtnDom.onclick = async () => {
    //    this.player.record().resume();
    //  }
    //});


    // user completed recording and stream is available
    this.player.on('finishRecord', () => {
      // recordedData is a blob object containing the recorded data that
      // can be downloaded by the user, stored on server etc.
      console.log('finished recording: ', this.player.recordedData);
      this.file = this.player.recordedData
      var myButton = this.player.controlBar.addChild("button");

      // There are many functions available for button component 
      // like below mentioned in this docs 
      // https://docs.videojs.com/button. 
      // You can set attributes and clasess as well.

      // Getting html DOM
      var myButtonDom = myButton.el();
      // Since now you have the html dom element 
      // you can add click events

      // Now I am setting the text as you needed.
      myButtonDom.className += ' fa';
      myButtonDom.innerHTML = "&#xf093;";
      myButtonDom.title = "Upload";
      myButtonDom.onclick = async () => {
        $('#entertitle').modal('show');
      }
    });

    // error handling
    this.player.on('error', (element, error) => {
      console.warn(error);
    });

    this.player.on('deviceError', () => {
      console.error('device error:', this.player.deviceErrorCode);
    });
  }

  // use ngOnDestroy to detach event handlers and remove the player
  ngOnDestroy() {
    if (this.player) {
      this.player.dispose();
      this.player = false;
    }
  }

  async uploadclicked() {

    if (!this.mediatitle) {
      this.toastr.error('Enter a title for the recording');
    }
    else {
      $('#entertitle').modal('hide');
      // this.headerinfo.setHeaderDisplay('Uploading...', [], []);

      this.headerinfo.pageLoadingStarted(this)
      this.toastr.info("Uploading...")
      await this.uploadMediaFile().catch(() => this.headerinfo.pageLoadingDone(this));
      this.headerinfo.pageLoadingDone(this);
      this.toastr.success("Recording Successfully Uploaded");
      this.router.navigate(['/user/modulemedialibrary'], { queryParams: { moduleid: this.moduleid } });
    }
  }

  async uploadMediaFile() {

    const f = this.file;
    const uploadid = Math.random().toString(36).substring(7);
    const chunksize = 1024 * 1024 * 0.5;

    const readFileChunk = function (_offset, length, _file) {
      return new Promise<ArrayBuffer>(function (accept, reject) {
        var r = new FileReader();
        r.onload = function (evt) {
          //debugger;
          accept(<ArrayBuffer>evt.target.result);
        }
        var blob = _file.slice(_offset, length + _offset);
        r.readAsArrayBuffer(blob);
      });
    };

    console.log("loop started")

    let offset: number = 0;
    for (let i = 0; !this.stop; i++) {
      let buffer: ArrayBuffer = await readFileChunk(offset, chunksize, f);

      if (buffer.byteLength > 0) {
        try {
          //debugger;
          const blob = new Blob([buffer]);
          //console.log(f.size);
          await this.modulemanager.uploadMediaFilePart(this.moduleid, uploadid, blob, i).toPromise();
          try {
            let percentage = ((i + 1) * chunksize) / f.size * 100;
            if (percentage > 100) {
              percentage = 100;
            }
            percentage = Math.floor(percentage);
            this.uploadpercentage = percentage;
            if (!this.stop) {
              this.headerinfo.setLoadingProgress(percentage);
            }
          } catch (error) {
            console.log(error);
          }
        }
        catch (error) {
          i--;
          continue;
        }
      }
      offset += buffer.byteLength;
      if (buffer.byteLength == 0) {
        await this.modulemanager.finishMediaFileUpload(this.moduleid, uploadid, f.name, f.type, this.mediatitle, f.size).toPromise();
        return;
      }
    }
    console.log("loop done")
  }
}
